import { all, put, takeEvery, call, select } from "redux-saga/effects";
import {
  MATERIAL_CATEGORIES_ACTIONS,
  MATERIAL_CATEGORIES_TYPES
} from "./actions";
import {
  getMaterialCategory as APIgetMaterialCategory,
  getMaterialCategories as APIgetMaterialCategories,
  createMaterialCategory as APIcreateMaterialCategory,
  updateMaterialCategory as APIupdateMaterialCategory,
  deleteMaterialCategory as APIdeleteMaterialCategory
} from "../../services/api/materialCategories";
import { createNavigateTo, navigateTo } from "../navigation/saga";
import { materialCategoriesFilters } from "./selectors";

export function* watchMaterialCategoriesActions() {
  yield all([
    takeEvery(MATERIAL_CATEGORIES_TYPES.LOAD_ALL_REQUEST, getMaterialCategories)
  ]);
  yield all([
    takeEvery(MATERIAL_CATEGORIES_TYPES.LOAD_REQUEST, getMaterialCategory)
  ]);
  yield all([
    takeEvery(MATERIAL_CATEGORIES_TYPES.CREATE_REQUEST, createMaterialCategory)
  ]);
  yield all([
    takeEvery(MATERIAL_CATEGORIES_TYPES.UPDATE_REQUEST, updateMaterialCategory)
  ]);
  yield all([
    takeEvery(MATERIAL_CATEGORIES_TYPES.DELETE_REQUEST, deleteMaterialCategory)
  ]);
  yield all([
    takeEvery(
      MATERIAL_CATEGORIES_TYPES.UPDATE_SUCCESS,
      createNavigateTo("/admin/material-categories")
    )
  ]);
  yield all([
    takeEvery(MATERIAL_CATEGORIES_TYPES.CREATE_SUCCESS, getMaterialCategories)
  ]);
  yield all([
    takeEvery(MATERIAL_CATEGORIES_TYPES.DELETE_SUCCESS, getMaterialCategories)
  ]);
  yield all([
    takeEvery(MATERIAL_CATEGORIES_TYPES.UPDATE_FILTERS, getMaterialCategories)
  ]);
}

function* getMaterialCategories() {
  try {
    const filters = yield select(materialCategoriesFilters);
    const materialCategories = yield call(APIgetMaterialCategories, filters);
    yield put(MATERIAL_CATEGORIES_ACTIONS.loadAllSuccess(materialCategories));
  } catch (e) {
    yield put(MATERIAL_CATEGORIES_ACTIONS.loadAllFailure(e));
  }
}

function* getMaterialCategory(action) {
  const { id } = action.payload;
  try {
    const materialCategory = yield call(APIgetMaterialCategory, id);
    yield put(MATERIAL_CATEGORIES_ACTIONS.loadSuccess(materialCategory));
  } catch (e) {
    yield put(MATERIAL_CATEGORIES_ACTIONS.loadFailure(e));
  }
}

function* createMaterialCategory(action) {
  const { values } = action.payload;
  try {
    const materialCategory = yield call(APIcreateMaterialCategory, values);
    yield put(MATERIAL_CATEGORIES_ACTIONS.createSuccess(materialCategory));
    yield call(navigateTo, "/admin/material-categories");
  } catch (e) {
    yield put(MATERIAL_CATEGORIES_ACTIONS.createFailure(e));
  }
}

function* updateMaterialCategory(action) {
  const { id, values } = action.payload;
  try {
    const materialCategory = yield call(APIupdateMaterialCategory, id, values);
    yield put(MATERIAL_CATEGORIES_ACTIONS.updateSuccess(materialCategory));
  } catch (e) {
    yield put(MATERIAL_CATEGORIES_ACTIONS.updateFailure(e));
  }
}

function* deleteMaterialCategory(action) {
  const { id } = action.payload;
  try {
    const materialCategory = yield call(APIdeleteMaterialCategory, id);
    yield put(MATERIAL_CATEGORIES_ACTIONS.deleteSuccess(materialCategory));
  } catch (e) {
    yield put(MATERIAL_CATEGORIES_ACTIONS.deleteFailure(e));
  }
}
